export const getNetworkConnectionType = () => {
    const windowNavigator: any = window.navigator;
    if (
        !windowNavigator ||
        (!windowNavigator.connection &&
            !windowNavigator.mozConnection &&
            !windowNavigator.webkitConnection)
    )
        return {};

    const connection =
        windowNavigator.connection ||
        windowNavigator.mozConnection ||
        windowNavigator.webkitConnection;
    return {
        connectionType: connection?.effectiveType || '',
        internetSpeed: connection?.downlink || '',
        ram: windowNavigator?.deviceMemory || '',
        timezone: Intl?.DateTimeFormat?.()?.resolvedOptions?.()?.timeZone || '',
        connectionRTT: connection?.rtt || '',
        connectionCategory: connection?.type || '',
        processors: windowNavigator?.hardwareConcurrency || '',
    };
};

const getAgentName = (userAgentInfo: string) => {
    if (userAgentInfo.includes('Edg')) return 'Microsoft Edge';
    if (userAgentInfo.includes('Firefox')) return 'Firefox';
    if (userAgentInfo.includes('Safari') && !userAgentInfo.includes('Chrome'))
        return 'Safari';
    if (userAgentInfo.includes('Chrome')) return 'Chrome';
    return '';
};

export const getDeviceInfo = () => {
    const ua = window.navigator.userAgent || '';
    const currentWidth = window?.innerWidth;
    const currentHeight = window?.innerHeight;
    const totalWidth = window?.screen?.width;
    const totalHeight = window?.screen?.height;

    let type = '';

    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        type = 'tablet';
    } else if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            ua
        )
    ) {
        type = 'mobile';
    } else {
        type = 'desktop';
    }

    const browserAgentName = getAgentName(ua);

    return {
        currentHeight,
        currentWidth,
        totalWidth,
        totalHeight,
        type,
        browserAgentName,
    };
};

export const getCurrentPageId = () => {
    if ((globalThis as any)?.currentPage)
        return (globalThis as any).currentPage;

    if ((window as any)?.currentPage) return (window as any).currentPage;

    return '';
};
